import { render, staticRenderFns } from "./FilterPillsList.vue?vue&type=template&id=385a55e8&scoped=true"
import script from "./FilterPillsList.vue?vue&type=script&lang=js"
export * from "./FilterPillsList.vue?vue&type=script&lang=js"
import style0 from "./FilterPillsList.vue?vue&type=style&index=0&id=385a55e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a55e8",
  null
  
)

export default component.exports